import { Container } from '@/components/container';
import { Demo3Content } from '.';
const Demo3Page = () => {
  return <Container>
      <Demo3Content />
    </Container>;
};
export { Demo3Page };